<template>
  <div class="sport-header">
    <div class="sport-header-wrapper" :class="{ mini }" data-t="sport-header">
      <header class="sport-header-title" data-t="title-sport">
        <StIcon class="sport-header-icon" :name="iconName" :size="24" />
        <h3 class="sport-header-text" data-t="sport-header-title">
          {{ title }}
        </h3>
      </header>
      <nav class="sport-header-nav" data-t="sport-header-nav">
        <MarketsFilterList
          v-if="filters.length"
          :filters="filters"
          @update-filters="handleChangeFilters"
        />

        <StIcon
          data-t="sport-header-icon-collapse"
          class="sport-header-collapse"
          :name="collapseIconName"
          :size="16"
          @click="toogleSportPanel"
        />
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IconName } from '@st/ui/components/StIcon/types'
import type { FilterConfig } from 'markets-store/marketsbook/types'
import MarketsFilterList from '../MarketsFilter/MarketsFilterList.vue'

interface Props {
  title: string
  filters: FilterConfig[]
  mini: boolean
  iconName: IconName
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  filters: () => [],
  mini: false,
})

const emit = defineEmits<{
  (e: 'toogleSport'): void
  (e: 'updateFilters', value: (FilterConfig | null)[]): void
}>()

const collapseIconName = computed(() =>
  props.mini ? 'chevron-down' : 'chevron-top',
)

function toogleSportPanel() {
  emit('toogleSport')
}

function handleChangeFilters(filters: (FilterConfig | null)[]) {
  emit('updateFilters', filters)
}
</script>

<style>
:root {
  --sport-header-top: 0px;
}
</style>
<style scoped>
.sport-header {
  position: sticky;
  z-index: 5;

  /* stylelint-disable */
  top: var(--sport-header-top);
  /* stylelint-enable */
  background-color: var(--background-base);
}

.sport-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 48px;
  padding: var(--spacing-100) var(--spacing-200);

  background-color: var(--background-primary);
  border-radius: var(--border-radius-150) var(--border-radius-150) 0 0;

  &.mini {
    border-radius: var(--border-radius-150);
  }
}

.sport-header-title {
  display: flex;
  gap: var(--spacing-100);
  align-items: center;
}

.sport-header-text {
  margin: 0;
  font: var(--desktop-text-md-semibold);
  color: var(--text-primary);
}

.sport-header-icon {
  color: var(--text-tertiary);
}

.sport-header-collapse {
  cursor: pointer;
  display: flex;
  margin-left: var(--spacing-200);
  color: var(--text-tertiary);

  &:hover {
    color: var(--text-primary);
  }
}

.sport-header-nav {
  display: flex;
  align-items: center;
}

.filters-list {
  width: 556px;
}
</style>
